import { createFileRoute } from "@tanstack/react-router";
import { MedicationsPage } from "@/modules/medications/presentation/pages/MedicationsPage";

export const Route = createFileRoute("/_authenticated/medications")({
  component: MedicationsPage,
});
